'use strict';

var injectDynamicUtils = {
    /**
     * @function
     * @desc inject JS dynamically
     * @param {string} id - the id of the hidden jss path element
     */
    injectDynamicJs: function (id) {
        let $el = $(id);
        if ($el.length && !$el.data('loaded')) {
            let url = $el.data('jspath');
            $('script[src="' + url + '"]').remove();
            $('<script>')
            .attr('type', 'text/javascript')
            .attr('src', url)
            .appendTo('head');
            $el.data('loaded', true);
        }
    },
    /**
     * @function
     * @desc inject CSS dynamically
     * @param {string} id - the id of the hidden jss path element
     */
    injectDynamicCSS: function (id) {
        let $el = $(id);
        if ($el.length && !$el.data('loaded')) {
            let url = $el.data('csspath');
            $('link[href="' + url + '"]').remove();
            $('<link/>', {
                rel: 'stylesheet',
                type: 'text/css',
                href: url
            }).appendTo('head');
            $el.data('loaded', true);
        }
    }
};

module.exports = injectDynamicUtils;
